var Model = require('../Model');

var Asset = Object.create(Model);

Asset.name = 'Asset';
Asset['@class'] = 'Asset';
Asset.url = 'asset';

Asset.fields = {
  point: {
    default: null,
    hidden: true
  },
  lastAction: {
    type: 'date',
    default: null
  },
  manufacturer: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  model: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  probeType: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  transmitterSerialNumber: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  probeSerialNumber: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  deleted:{}
};

module.exports = Asset;
